// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"538":"recorder","983":"profiler"}[chunkId] || chunkId) + "." + {"538":"277014c38c90f91e","835":"12f2bfcb9226cf69","898":"fd8bfa2092c915b5","983":"c1ee31ccf72c1bf9"}[chunkId] + ".js";
};